import React, { useEffect, useCallback, useRef } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export const Lightbox = ({ images, index, onClose, onChange }) => {
  const closeRef = useRef(null);
  const prev = useCallback(() => onChange((index - 1 + images.length) % images.length), [index, images.length, onChange]);
  const next = useCallback(() => onChange((index + 1) % images.length), [index, images.length, onChange]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    const prevFocus = document.activeElement;
    closeRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
      prevFocus?.focus?.();
    };
  }, [onClose, prev, next]);

  return (
    <div className="lightbox" onClick={onClose} role="dialog" aria-modal="true" aria-label="Image viewer" data-testid="lightbox">
      <button ref={closeRef} className="lightbox-btn lightbox-close" onClick={onClose} aria-label="Close" data-testid="lightbox-close">
        <X size={22} strokeWidth={1.2} />
      </button>
      {images.length > 1 && (
        <>
          <button className="lightbox-btn lightbox-prev" onClick={(e) => { e.stopPropagation(); prev(); }} aria-label="Previous" data-testid="lightbox-prev">
            <ChevronLeft size={28} strokeWidth={1.2} />
          </button>
          <button className="lightbox-btn lightbox-next" onClick={(e) => { e.stopPropagation(); next(); }} aria-label="Next" data-testid="lightbox-next">
            <ChevronRight size={28} strokeWidth={1.2} />
          </button>
        </>
      )}
      <div className="lightbox-stage" onClick={(e) => e.stopPropagation()}>
        <img key={index} src={images[index]} alt="" className="lightbox-img" draggable={false} data-testid="lightbox-image" />
        <div className="lightbox-shield" />
      </div>
      <div className="lightbox-counter" data-testid="lightbox-counter">
        {index + 1} / {images.length}
      </div>
    </div>
  );
};
